import { Reducer } from 'redux';
import { TeamLocalState, TeamLocalActionTypes } from './types';

export const initialState: TeamLocalState = {
  teams: []
};

const reducer: Reducer<TeamLocalState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case TeamLocalActionTypes.GET_TEAMS_START:
      return {
        ...state,
        loading: true
      };
    case TeamLocalActionTypes.GET_TEAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        teams: action.payload
      };
    case TeamLocalActionTypes.GET_TEAMS_FAILURE:
      return {
        ...state,
        loading: false,
        teams: []
      };
    default:
      return state;
  }
};

export default reducer;
